<template>
    <div class="studentActivity">
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: "teacherTextbook",
    components: {},
    data() {
      return {};
    },
    created() {},
  
    methods: {},
  };
  </script>
  
  <style scoped lang="scss">
  .studentActivity {
    width: 100%;
    height: 100%;
  }
  </style>